import { EntityActions } from '~/apps/shared/actions/consts';
import { SaleActions } from '../actions/consts';
import { Sale } from '../../models';


type SaleUIState = {
  currentList: [],
  loading: false,
  errorMessage: string,
  currentPage: number,
};

type SaleState = {
  entities: {[id: string]: Sale},
  ui: SaleUIState,
};

const defaultState: SaleState = {
  entities: {},
  ui: {
    currentList: [],
    loading: false,
    errorMessage: '',
    currentPage: 0,
  }
};

export function sales(state: SaleState = defaultState, action) {
  switch (action.type) {
    case EntityActions.ADD_ENTITIES:
      return {
        ...state,
        entities: {
          ...state.entities,
          ...action.entities.sales,
        }
      };
    case SaleActions.LOAD_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
        }
      };
    case SaleActions.LOAD_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
        }
      };
    case SaleActions.LOAD_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
        }
      };
    case SaleActions.LOAD_LIST_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
          currentList: action.result,
        }
      };
    case SaleActions.SET_CURRENT_PAGE:
      return {
        ...state,
        ui: {
          ...state.ui,
          currentPage: action.currentPage,
        }
      };
    default:
      return state;
  }
}
